(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@fdn/rating-star')) :
  typeof define === 'function' && define.amd ? define('@fdn/product_card', ['react', '@fdn/rating-star'], factory) :
  (global = global || self, global['@fdn/product_card'] = factory(global.React, global.RatingStar));
}(this, (function (React, RatingStar) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  RatingStar = RatingStar && Object.prototype.hasOwnProperty.call(RatingStar, 'default') ? RatingStar['default'] : RatingStar;

  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement("div", {
      id: props.element_id,
      className: "product-card".concat(props.default_class ? ' ' + props.default_class : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.image_id,
      href: props.product_url_image
    }, /*#__PURE__*/React.createElement("img", {
      src: props.product_image
    }))), /*#__PURE__*/React.createElement("div", {
      className: "text-wrapper"
    }, !!props.matches ? /*#__PURE__*/React.createElement("p", {
      className: "product-match-text"
    }, "Match your ", props.matches) : null, !!props.rating ? props.rating == '0' ? /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-first-review"
    }, "Be the first to review!")) : /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rating-text"
    }, props.rating), /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      rating: props.rating
    }), !!props.total_rating ? /*#__PURE__*/React.createElement("span", {
      className: "rating-total"
    }, "(", props.total_rating, ")") : null) : null, !!props.brand_name ? /*#__PURE__*/React.createElement("h3", {
      className: "product-brand"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.brand_id,
      href: props.brand_url
    }, props.brand_name)) : null, !!props.product_name ? /*#__PURE__*/React.createElement("p", {
      className: "product-name"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.product_id,
      href: props.product_url
    }, props.product_name)) : null, !!props.product_shade ? /*#__PURE__*/React.createElement("p", {
      className: "product-shade"
    }, props.product_shade) : null, !!props.product_price ? /*#__PURE__*/React.createElement("p", {
      className: "product-price"
    }, props.product_price) : null), /*#__PURE__*/React.createElement("style", null, "\n          .product-card {\n            display: ".concat(props.card_position == 'inline' ? 'flex' : 'block', ";\n            ").concat(props.card_position == 'inline' ? props.card_align == 'right' ? 'flex-direction: row-reverse;' : '' : '', "\n          }\n\n          .product-card .image-wrapper {\n            display: flex;\n            height: 177px;\n            width: ").concat(props.card_position == 'inline' ? '80px' : '100%', ";\n            min-width: ").concat(props.card_position == 'inline' ? '80px' : '100%', ";\n            flex-wrap: wrap;\n            justify-content: center;\n            align-items: center;\n            overflow: hidden;\n            margin-right: ").concat((props.card_align == 'left' || props.card_align == 'center') && props.card_position == 'inline' ? '10px' : '0', ";\n            margin-left: ").concat(props.card_align == 'right' && props.card_position == 'inline' ? '10px' : '0', ";\n            margin-bottom: ").concat(props.card_position !== 'inline' ? '15px' : '0', ";\n          }\n\n          .product-card .image-wrapper a[href] {\n            cursor: pointer;\n          }\n\n          .product-card .image-wrapper img {\n            max-height: 100%;\n            max-width: 100%;\n          }\n\n          .product-card .rating-wrapper {\n            display: flex;\n            flex-flow: row;\n            justify-content: ").concat(props.card_align == 'center' ? 'center' : props.card_align == 'right' ? 'flex-end' : 'flex-start', ";\n            align-items: baseline;\n            margin-bottom: 10px;\n          }\n\n          .product-card .rating-wrapper .rating-text {\n            font-family: Roboto;\n            font-size: 14px;\n            color: #000000;\n            margin-right: 10px;\n            font-weight: bold;\n            line-height: 1.71;\n            letter-spacing: 1px;\n          }\n\n          .product-card .rating-wrapper .rating-total {\n            font-family: Roboto;\n            font-size: 14px;\n            color: #000;\n            margin-left: 10px;\n          }\n\n          .product-card .rating-wrapper .text-first-review {\n            font-family: Roboto;\n            font-style: normal;\n            font-weight: normal;\n            font-size: 14px;\n            line-height: 24px;\n            margin-top: 0;\n            color: #DB284E;\n          }\n\n          .product-card .text-wrapper p:nth-last-child(1) {\n            margin-bottom: 0;\n          }\n\n          .product-card .text-wrapper p {\n            font-family: Roboto, sans-serif;\n            font-size: 16px;\n            font-weight: normal;\n            line-height: 22px;\n            display: -webkit-box;\n            white-space: normal;\n            -webkit-line-clamp: ").concat(props.product_texts_lines, ";\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n\n          .product-card .text-wrapper a,\n          .product-card .text-wrapper .product-brand {\n            display: -webkit-box;\n            white-space: normal;\n            -webkit-line-clamp: ").concat(props.product_texts_lines, ";\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n\n          .product-card .text-wrapper p,\n          .product-card .product-brand {\n            text-align: ").concat(props.card_align, ";\n            margin-top: 0;\n          }\n\n          .product-card .text-wrapper .product-match-text {\n            font-family: Roboto;\n            font-size: 14px;\n            font-weight: 700;\n            line-height: 16px;\n            color: #000;\n            margin-bottom: 16px;\n            white-space: normal;\n            -webkit-line-clamp: unset;\n            -webkit-box-orient: vertical;\n            overflow: visible;\n          }\n\n          .product-card .text-wrapper .product-brand {\n            font-family: Poppins, sans-serif;\n            font-size: 16px;\n            font-weight: 600;\n            color: #000;\n            margin: 0 0 7px;\n          }\n\n          .product-card .text-wrapper .product-name {\n            color: #000;\n            margin-bottom: 2.5px;\n          }\n\n          .product-card .text-wrapper .product-shade {\n            color: #9b9b9b;\n            line-height: 1.38;\n            margin: 3px 0 0 0;\n          }\n\n          .product-card .text-wrapper .product-price {\n            font-weight: bold;\n            color: #DB284E;\n            margin: 0;\n          }\n\n          .product-card a {\n            transition: all .3s ease;\n            color: inherit;\n          }\n\n          .product-card a[href]:hover {\n            color: #DB284E;\n          }\n\n          .product-card .image-wrapper a[href]:hover {\n            opacity: .8;\n          }\n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      id: props.element_id,
      className: "product-card".concat(props.default_class ? ' ' + props.default_class : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.image_id,
      href: props.product_url_image
    }, /*#__PURE__*/React.createElement("img", {
      src: props.product_image
    }))), /*#__PURE__*/React.createElement("div", {
      className: "text-wrapper"
    }, !!props.matches ? /*#__PURE__*/React.createElement("p", {
      className: "product-match-text"
    }, "Match your ", props.matches) : null, !!props.rating && props.card_position !== 'inline' ? props.rating == '0' ? /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-first-review"
    }, "Be the first to review!")) : /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rating-text"
    }, props.rating), /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      rating: props.rating
    }), !!props.total_rating ? /*#__PURE__*/React.createElement("span", {
      className: "rating-total"
    }, "(", props.total_rating, ")") : null) : null, !!props.brand_name ? /*#__PURE__*/React.createElement("h3", {
      className: "product-brand"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.brand_id,
      href: props.brand_url
    }, props.brand_name)) : null, !!props.product_name ? /*#__PURE__*/React.createElement("p", {
      className: "product-name"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.product_id,
      href: props.product_url
    }, props.product_name)) : null, !!props.product_shade ? /*#__PURE__*/React.createElement("p", {
      className: "product-shade"
    }, props.product_shade) : null, !!props.product_price ? /*#__PURE__*/React.createElement("p", {
      className: "product-price"
    }, props.product_price) : null, !!props.rating && props.card_position === 'inline' ? props.rating == '0' ? /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-first-review"
    }, "BE THE FIRST TO REVIEW!")) : /*#__PURE__*/React.createElement("div", {
      className: "rating-wrapper"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rating-text"
    }, props.rating), /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      rating: props.rating
    }), !!props.total_rating ? /*#__PURE__*/React.createElement("span", {
      className: "rating-total"
    }, "(", props.total_rating, ")") : null) : null), /*#__PURE__*/React.createElement("style", null, "\n          .product-card {\n            display: ".concat(props.card_position == 'inline' ? 'flex' : 'block', ";\n            ").concat(props.card_position == 'inline' ? props.card_align == 'right' ? 'flex-direction: row-reverse;' : '' : '', "\n          }\n\n          .product-card .image-wrapper {\n            display: flex;\n            height: 122.5px;\n            width: ").concat(props.card_position == 'inline' ? '80px' : '100%', ";\n            min-width: ").concat(props.card_position == 'inline' ? '80px' : '100%', ";\n            flex-wrap: wrap;\n            justify-content: center;\n            align-items: center;\n            overflow: hidden;\n            margin-right: ").concat((props.card_align == 'left' || props.card_align == 'center') && props.card_position == 'inline' ? '10px' : '0', ";\n            margin-left: ").concat(props.card_align == 'right' && props.card_position == 'inline' ? '10px' : '0', ";\n            margin-bottom: ").concat(props.card_position !== 'inline' ? '10px' : '0', ";\n          }\n\n          .product-card .image-wrapper img {\n            max-height: 100%;\n            max-width: 100%;\n          }\n\n          .product-card .rating-wrapper {\n            display: flex;\n            flex-flow: row;\n            justify-content: ").concat(props.card_align == 'center' ? 'center' : props.card_align == 'right' ? 'flex-end' : 'flex-start', ";\n            align-items: baseline;\n            margin-bottom: 5px;\n          }\n\n          .product-card .rating-wrapper .rating-text {\n            font-family: Roboto;\n            font-size: 12px;\n            color: #000000;\n            margin-right: 5px;\n            font-weight: bold;\n            line-height: 1.71;\n            letter-spacing: 1px;\n          }\n\n          .product-card .rating-wrapper .rating-total {\n            font-family: Roboto;\n            font-size: 12px;\n            color: #000;\n            margin-left: 5px;\n          }\n\n          .product-card .rating-wrapper .text-first-review {\n            font-family: Roboto;\n            font-style: normal;\n            font-weight: normal;\n            font-size: 12px;\n            line-height: 24px;\n            margin-top: 0;\n            color: #DB284E;\n          }\n\n          .product-card .text-wrapper p:nth-last-child(1) {\n            margin-bottom: 0;\n          }\n\n          .product-card .text-wrapper p {\n            font-family: Roboto, sans-serif;\n            font-size: 12px;\n            font-weight: normal;\n            line-height: 18px;\n            display: -webkit-box;\n            white-space: normal;\n            -webkit-line-clamp: ").concat(props.product_texts_lines, ";\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n\n          .product-card .text-wrapper a,\n          .product-card .text-wrapper .product-brand {\n            display: -webkit-box;\n            white-space: normal;\n            -webkit-line-clamp: ").concat(props.product_texts_lines, ";\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n\n          .product-card .text-wrapper p,\n          .product-card .product-brand {\n            text-align: ").concat(props.card_align, ";\n            margin-top: 0;\n          }\n\n          .product-card .text-wrapper .product-match-text {\n            font-size: 10px;\n            font-weight: 700;\n            line-height: 12px;\n            color: #000;\n            margin-bottom: 5px;\n            white-space: normal;\n            -webkit-line-clamp: unset;\n            -webkit-box-orient: vertical;\n            overflow: visible;\n          }\n\n          .product-card .text-wrapper .product-brand {\n            font-family: Poppins, sans-serif;\n            font-size: 12px;\n            line-height: 18px;\n            font-weight: bold;\n            color: #000;\n            margin: 0 0 6.2px;\n          }\n\n          .product-card .text-wrapper .product-name {\n            color: #000;\n            margin-bottom: 1.2px;\n          }\n\n          .product-card .text-wrapper .product-shade {\n            color: #9b9b9b;\n            line-height: 1.38;\n            margin: 3px 0 0 0;\n          }\n\n          .product-card .text-wrapper .product-price {\n            font-weight: bold;\n            color: #DB284E;\n            margin: 0;\n          }\n\n          .product-card a {\n            transition: all .3s ease;\n            color: inherit;\n          }\n\n          .product-card a[href]:hover {\n            color: #DB284E;\n          }\n\n          .product-card .image-wrapper a[href]:hover {\n            opacity: .8;\n          }\n        ")));
  };

  var DesktopAltoshift = function DesktopAltoshift(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "product-card-altoshift"
    }, /*#__PURE__*/React.createElement("a", {
      href: props.product_url ? props.product_url : props.reviews_link + props.link.path,
      className: "product-image"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      src: props.product_image ? props.product_image : !!props.product.image && props.product.image !== "" ? props.product.image : "https://image.femaledaily.com/dyn/200/images/prod-pics/placeholder_product.png",
      alt: "product"
    })), /*#__PURE__*/React.createElement("div", {
      className: "detail-wrapper"
    }, props.product_total_rating > 0 || props.product.rating.total > 0 ? /*#__PURE__*/React.createElement("p", {
      className: "product-detail"
    }, /*#__PURE__*/React.createElement("span", {
      className: "product-rating-average"
    }, props.product_rating ? props.product_rating : props.product.rating.average), /*#__PURE__*/React.createElement("span", {
      className: "product-rating-stars"
    }, /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      type: 1,
      rating: props.product_rating ? props.product_rating : props.product.rating.average
    })), /*#__PURE__*/React.createElement("span", {
      className: "product-rating-total"
    }, "(", props.product_total_rating ? props.product_total_rating : props.product.rating.total, ")")) : /*#__PURE__*/React.createElement("p", {
      className: "product-text-first-review"
    }, "be the first to review!"), /*#__PURE__*/React.createElement("a", {
      href: props.product_url ? props.product_url : props.reviews_link + props.link.path,
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      className: "product-title",
      id: props.element_id
    }, props.product_name ? props.product_name : props.product.name), props.product.shade || props.product_shade ? /*#__PURE__*/React.createElement("p", {
      className: "product-shade"
    }, props.product_shade ? props.product_shade : props.product.shade) : null, props.product.brand || !!props.brand_name && !!props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: props.brand_url ? props.brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: "product-brand"
    }, props.brand_name ? props.brand_name : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: "product-brand"
    }, props.brand_name ? props.brand_name : props.product.brand.name)), /*#__PURE__*/React.createElement("style", null, "\n        .product-card-altoshift {\n          display: flex;\n          width: 100%;\n          align-items: center;\n          font-family: Roboto, sans-serif;\n          cursor: pointer;\n        }\n\n        .product-card-altoshift p {\n          margin: 0;\n        }\n\n        .product-card-altoshift a {\n          text-decoration: none;\n          transition: all .4s ease-out;\n        }\n\n        .product-card-altoshift a:hover {\n          color: #D7244E !important;\n        }\n\n        .product-card-altoshift .product-image {\n          width: 17%;\n          max-width: 17%;\n          margin-right: 16px;\n          transition: all .4s ease-out;\n          opacity: 1;\n        }\n\n        .product-card-altoshift .product-image:hover {\n          opacity: .6;\n        }\n\n        .product-card-altoshift .detail-wrapper {\n          width: calc(83% - 16px);\n          max-width: calc(83% - 16px);\n        }\n\n        .product-card-altoshift .product-image img {\n          max-width: 100%;\n        }\n\n        .product-card-altoshift .product-detail {\n          display: flex;\n          align-items: center;\n        }\n\n        .product-card-altoshift .product-rating-average {\n          font-style: normal;\n          font-weight: bold;\n          font-size: 12px;\n          line-height: 14px;\n          color: #000000;\n        }\n\n        .product-card-altoshift .product-rating-stars {\n          margin: 0 4px;\n        }\n\n        .product-card-altoshift .product-rating-stars i {\n          font-size: 10px;\n        }\n\n        .product-card-altoshift .product-rating-total {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #C4CDD5;\n        }\n\n        .product-card-altoshift .product-title {\n          font-family: Poppins, sans-serif;\n          font-weight: 600;\n          font-size: 14px;\n          line-height: 16px;\n          color: #000000;\n          text-decoration: none;\n          margin-top: 4px;\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;  \n          overflow: hidden;\n        }\n\n        .product-card-altoshift .product-shade {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #454F5B;\n          margin-top: 4px;\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;  \n          overflow: hidden;\n        }\n\n        .product-card-altoshift .product-brand {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #C4CDD5;\n          margin-top: 4px;\n          display: block;\n          text-decoration: none;\n        }\n\n        .product-card-altoshift .product-text-first-review {\n          font-size: 12px;\n        }\n      "));
  };

  var MobileAltoshift = function MobileAltoshift(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "product-card-altoshift"
    }, /*#__PURE__*/React.createElement("a", {
      href: props.product_url ? props.product_url : props.reviews_link + props.link.path,
      className: "product-image"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      src: props.product_image ? props.product_image : !!props.product.image && props.product.image !== "" ? props.product.image : "https://image.femaledaily.com/dyn/60/images/prod-pics/placeholder_product.png",
      alt: "product"
    })), /*#__PURE__*/React.createElement("div", {
      className: "product-detail"
    }, props.product_total_rating > 0 || props.product.rating.total > 0 ? /*#__PURE__*/React.createElement("p", {
      className: "product-rating"
    }, /*#__PURE__*/React.createElement("span", {
      className: "product-rating-average"
    }, props.product_rating ? props.product_rating : props.product.rating.average), /*#__PURE__*/React.createElement("span", {
      className: "product-rating-stars"
    }, /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      type: 1,
      rating: props.product_rating ? props.product_rating : props.product.rating.average
    })), /*#__PURE__*/React.createElement("span", {
      className: "product-rating-total"
    }, "(", props.product_rating ? props.product_rating : props.product.rating.total, ")")) : /*#__PURE__*/React.createElement("p", {
      className: "product-text-first-review"
    }, "be the first to review!"), /*#__PURE__*/React.createElement("a", {
      href: props.product_url ? props.product_url : props.reviews_link + props.link.path,
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      className: "product-title",
      id: props.element_id
    }, props.product_name ? props.product_name : props.product.name), props.product_shade ? props.product_shade : props.product.shade ? /*#__PURE__*/React.createElement("p", {
      className: "product-shade"
    }, props.product_shade ? props.product_shade : props.product.shade) : null, props.product.brand || props.brand_name && props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: props.brand_url ? brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: "product-brand"
    }, props.brand_name ? props.brand_name : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: "product-brand"
    }, props.brand_name ? props.brand_name : props.product.brand.name)), /*#__PURE__*/React.createElement("style", null, "\n        .product-card-altoshift {\n          display: flex;\n          width: 100%;\n          align-items: center;\n          font-family: Roboto, sans-serif;\n          cursor: pointer;\n        }\n\n        .product-card-altoshift p {\n          margin: 0;\n        }\n\n        .product-card-altoshift a {\n          text-decoration: none;\n          transition: all .4s ease-out;\n        }\n\n        .product-card-altoshift a:hover {\n          color: #D7244E !important;\n        }\n\n        .product-card-altoshift .product-detail {\n          width: 79.2%;\n          max-width: 79.2%;\n        }\n\n        .product-card-altoshift .product-image {\n          width: 20.8%;\n          max-width: 20.5%;\n          margin-right: 16px;\n          transition: all .4s ease-out;\n          opacity: 1;\n        }\n\n        .product-card-altoshift .product-image:hover {\n          opacity: .6;\n        }\n\n        .product-card-altoshift .detail-wrapper {\n          width: calc(79.5% - 16px);\n          max-width: calc(79.5% - 16px);\n        }\n\n        .product-card-altoshift .product-image img {\n          max-width: 100%;\n        }\n\n        .product-card-altoshift .product-rating {\n          display: flex;\n          align-items: center;\n        }\n\n        .product-card-altoshift .product-rating-average {\n          font-style: normal;\n          font-weight: bold;\n          font-size: 12px;\n          line-height: 14px;\n          color: #000000;\n        }\n\n        .product-card-altoshift .product-rating-stars {\n          margin: 0 4px;\n        }\n\n        .product-card-altoshift .product-rating-total {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #C4CDD5;\n        }\n\n        .product-card-altoshift .product-title {\n          font-family: Poppins, sans-serif;\n          font-weight: 600;\n          font-size: 14px;\n          line-height: 16px;\n          color: #000000;\n          text-decoration: none;\n          margin-top: 4px;\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;  \n          overflow: hidden;\n        }\n\n        .product-card-altoshift .product-shade {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #454F5B;\n          margin-top: 4px;\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;  \n          overflow: hidden;\n        }\n\n        .product-card-altoshift .product-brand {\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 14px;\n          color: #C4CDD5;\n          margin-top: 4px;\n          display: block;\n          text-decoration: none;\n        }\n\n        .product-card-altoshift .product-text-first-review {\n          font-size: 12px;\n        }\n      "));
  };

  function _interopDefaultLegacy(e) {
    return e && _typeof(e) === 'object' && 'default' in e ? e : {
      'default': e
    };
  }
  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  /*
  Based on Glamor's sheet
  https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
  */
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  var isProd = typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production";
  var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
  };
  var StyleSheet = /*#__PURE__*/function () {
    function StyleSheet(param) {
      var ref = param === void 0 ? {} : param,
        _name = ref.name,
        name = _name === void 0 ? "stylesheet" : _name,
        _optimizeForSpeed = ref.optimizeForSpeed,
        optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
      invariant$1(isString(name), "`name` must be a string");
      this._name = name;
      this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
      invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
      this._optimizeForSpeed = optimizeForSpeed;
      this._serverSheet = undefined;
      this._tags = [];
      this._injected = false;
      this._rulesCount = 0;
      var node = typeof window !== "undefined" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
      invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
      invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
      this.flush();
      this._optimizeForSpeed = bool;
      this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
      return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
      var _this = this;
      invariant$1(!this._injected, "sheet already injected");
      this._injected = true;
      if (typeof window !== "undefined" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name);
        this._optimizeForSpeed = "insertRule" in this.getSheet();
        if (!this._optimizeForSpeed) {
          if (!isProd) {
            console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
          }
          this.flush();
          this._injected = true;
        }
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function insertRule(rule, index) {
          if (typeof index === "number") {
            _this._serverSheet.cssRules[index] = {
              cssText: rule
            };
          } else {
            _this._serverSheet.cssRules.push({
              cssText: rule
            });
          }
          return index;
        },
        deleteRule: function deleteRule(index) {
          _this._serverSheet.cssRules[index] = null;
        }
      };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
      if (tag.sheet) {
        return tag.sheet;
      }
      // this weirdness brought to you by firefox
      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].ownerNode === tag) {
          return document.styleSheets[i];
        }
      }
    };
    _proto.getSheet = function getSheet() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
      invariant$1(isString(rule), "`insertRule` accepts only strings");
      if (typeof window === "undefined") {
        if (typeof index !== "number") {
          index = this._serverSheet.cssRules.length;
        }
        this._serverSheet.insertRule(rule, index);
        return this._rulesCount++;
      }
      if (this._optimizeForSpeed) {
        var sheet = this.getSheet();
        if (typeof index !== "number") {
          index = sheet.cssRules.length;
        }
        // this weirdness for perf, and chrome's weird bug
        // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
        try {
          sheet.insertRule(rule, index);
        } catch (error) {
          if (!isProd) {
            console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
          }
          return -1;
        }
      } else {
        var insertionPoint = this._tags[index];
        this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
      }
      return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
      if (this._optimizeForSpeed || typeof window === "undefined") {
        var sheet = typeof window !== "undefined" ? this.getSheet() : this._serverSheet;
        if (!rule.trim()) {
          rule = this._deletedRulePlaceholder;
        }
        if (!sheet.cssRules[index]) {
          // @TBD Should we throw an error?
          return index;
        }
        sheet.deleteRule(index);
        try {
          sheet.insertRule(rule, index);
        } catch (error) {
          if (!isProd) {
            console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
          }
          // In order to preserve the indices we insert a deleteRulePlaceholder
          sheet.insertRule(this._deletedRulePlaceholder, index);
        }
      } else {
        var tag = this._tags[index];
        invariant$1(tag, "old rule at index `" + index + "` not found");
        tag.textContent = rule;
      }
      return index;
    };
    _proto.deleteRule = function deleteRule(index) {
      if (typeof window === "undefined") {
        this._serverSheet.deleteRule(index);
        return;
      }
      if (this._optimizeForSpeed) {
        this.replaceRule(index, "");
      } else {
        var tag = this._tags[index];
        invariant$1(tag, "rule at index `" + index + "` not found");
        tag.parentNode.removeChild(tag);
        this._tags[index] = null;
      }
    };
    _proto.flush = function flush() {
      this._injected = false;
      this._rulesCount = 0;
      if (typeof window !== "undefined") {
        this._tags.forEach(function (tag) {
          return tag && tag.parentNode.removeChild(tag);
        });
        this._tags = [];
      } else {
        // simpler on server
        this._serverSheet.cssRules = [];
      }
    };
    _proto.cssRules = function cssRules() {
      var _this = this;
      if (typeof window === "undefined") {
        return this._serverSheet.cssRules;
      }
      return this._tags.reduce(function (rules, tag) {
        if (tag) {
          rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function (rule) {
            return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
          }));
        } else {
          rules.push(null);
        }
        return rules;
      }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
      if (cssString) {
        invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
      }
      var tag = document.createElement("style");
      if (this._nonce) tag.setAttribute("nonce", this._nonce);
      tag.type = "text/css";
      tag.setAttribute("data-" + name, "");
      if (cssString) {
        tag.appendChild(document.createTextNode(cssString));
      }
      var head = document.head || document.getElementsByTagName("head")[0];
      if (relativeToTag) {
        head.insertBefore(tag, relativeToTag);
      } else {
        head.appendChild(tag);
      }
      return tag;
    };
    _createClass(StyleSheet, [{
      key: "length",
      get: function get() {
        return this._rulesCount;
      }
    }]);
    return StyleSheet;
  }();
  function invariant$1(condition, message) {
    if (!condition) {
      throw new Error("StyleSheet: " + message + ".");
    }
  }
  function hash(str) {
    var _$hash = 5381,
      i = str.length;
    while (i) {
      _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return _$hash >>> 0;
  }
  var stringHash = hash;
  var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
  };
  var cache = {};
  /**
   * computeId
   *
   * Compute and memoize a jsx id from a basedId and optionally props.
   */
  function computeId(baseId, props) {
    if (!props) {
      return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
      cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
  }
  /**
   * computeSelector
   *
   * Compute and memoize dynamic selectors.
   */
  function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (typeof window === "undefined") {
      css = sanitize(css);
    }
    var idcss = id + css;
    if (!cache[idcss]) {
      cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
  }
  function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function (args) {
      var id = args[0];
      var css = args[1];
      return /*#__PURE__*/React__default["default"].createElement("style", {
        id: "__" + id,
        // Avoid warnings upon render with a key
        key: "__" + id,
        nonce: options.nonce ? options.nonce : undefined,
        dangerouslySetInnerHTML: {
          __html: css
        }
      });
    });
  }
  var StyleSheetRegistry = /*#__PURE__*/function () {
    function StyleSheetRegistry(param) {
      var ref = param === void 0 ? {} : param,
        _styleSheet = ref.styleSheet,
        styleSheet = _styleSheet === void 0 ? null : _styleSheet,
        _optimizeForSpeed = ref.optimizeForSpeed,
        optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
      this._sheet = styleSheet || new StyleSheet({
        name: "styled-jsx",
        optimizeForSpeed: optimizeForSpeed
      });
      this._sheet.inject();
      if (styleSheet && typeof optimizeForSpeed === "boolean") {
        this._sheet.setOptimizeForSpeed(optimizeForSpeed);
        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
      }
      this._fromServer = undefined;
      this._indices = {};
      this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
      var _this = this;
      if (undefined === this._optimizeForSpeed) {
        this._optimizeForSpeed = Array.isArray(props.children);
        this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
      }
      if (typeof window !== "undefined" && !this._fromServer) {
        this._fromServer = this.selectFromServer();
        this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
          acc[tagName] = 0;
          return acc;
        }, {});
      }
      var ref = this.getIdAndRules(props),
        styleId = ref.styleId,
        rules = ref.rules;
      // Deduping: just increase the instances count.
      if (styleId in this._instancesCounts) {
        this._instancesCounts[styleId] += 1;
        return;
      }
      var indices = rules.map(function (rule) {
        return _this._sheet.insertRule(rule);
      }) // Filter out invalid rules
      .filter(function (index) {
        return index !== -1;
      });
      this._indices[styleId] = indices;
      this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
      var _this = this;
      var styleId = this.getIdAndRules(props).styleId;
      invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
      this._instancesCounts[styleId] -= 1;
      if (this._instancesCounts[styleId] < 1) {
        var tagFromServer = this._fromServer && this._fromServer[styleId];
        if (tagFromServer) {
          tagFromServer.parentNode.removeChild(tagFromServer);
          delete this._fromServer[styleId];
        } else {
          this._indices[styleId].forEach(function (index) {
            return _this._sheet.deleteRule(index);
          });
          delete this._indices[styleId];
        }
        delete this._instancesCounts[styleId];
      }
    };
    _proto.update = function update(props, nextProps) {
      this.add(nextProps);
      this.remove(props);
    };
    _proto.flush = function flush() {
      this._sheet.flush();
      this._sheet.inject();
      this._fromServer = undefined;
      this._indices = {};
      this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
      var _this = this;
      var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
        return [styleId, _this._fromServer[styleId]];
      }) : [];
      var cssRules = this._sheet.cssRules();
      return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
        return [styleId, _this._indices[styleId].map(function (index) {
          return cssRules[index].cssText;
        }).join(_this._optimizeForSpeed ? "" : "\n")];
      }) // filter out empty rules
      .filter(function (rule) {
        return Boolean(rule[1]);
      }));
    };
    _proto.styles = function styles(options) {
      return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
      var css = props.children,
        dynamic = props.dynamic,
        id = props.id;
      if (dynamic) {
        var styleId = computeId(id, dynamic);
        return {
          styleId: styleId,
          rules: Array.isArray(css) ? css.map(function (rule) {
            return computeSelector(styleId, rule);
          }) : [computeSelector(styleId, css)]
        };
      }
      return {
        styleId: computeId(id),
        rules: Array.isArray(css) ? css : [css]
      };
    };
    /**
    * selectFromServer
    *
    * Collects style tags from the document with id __jsx-XXX
    */
    _proto.selectFromServer = function selectFromServer() {
      var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return elements.reduce(function (acc, element) {
        var id = element.id.slice(2);
        acc[id] = element;
        return acc;
      }, {});
    };
    return StyleSheetRegistry;
  }();
  function invariant(condition, message) {
    if (!condition) {
      throw new Error("StyleSheetRegistry: " + message + ".");
    }
  }
  var StyleSheetContext = /*#__PURE__*/React.createContext(null);
  StyleSheetContext.displayName = "StyleSheetContext";
  function createStyleRegistry() {
    return new StyleSheetRegistry();
  }
  function StyleRegistry(param) {
    var configuredRegistry = param.registry,
      children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function () {
        return rootRegistry || configuredRegistry || createStyleRegistry();
      }),
      registry = ref[0];
    return /*#__PURE__*/React__default["default"].createElement(StyleSheetContext.Provider, {
      value: registry
    }, children);
  }
  function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
  }

  // Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
  // https://github.com/reactwg/react-18/discussions/110
  var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
  var defaultRegistry = typeof window !== "undefined" ? createStyleRegistry() : undefined;
  function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
      return null;
    }
    if (typeof window === "undefined") {
      registry.add(props);
      return null;
    }
    useInsertionEffect(function () {
      registry.add(props);
      return function () {
        registry.remove(props);
      };
      // props.children can be string[], will be striped since id is identical
    }, [props.id, String(props.dynamic)]);
    return null;
  }
  JSXStyle.dynamic = function (info) {
    return info.map(function (tagInfo) {
      var baseId = tagInfo[0];
      var props = tagInfo[1];
      return computeId(baseId, props);
    }).join(" ");
  };
  var StyleRegistry_1 = StyleRegistry;
  var createStyleRegistry_1 = createStyleRegistry;
  var style = JSXStyle;
  var useStyleRegistry_1 = useStyleRegistry;
  var index = {
    StyleRegistry: StyleRegistry_1,
    createStyleRegistry: createStyleRegistry_1,
    style: style,
    useStyleRegistry: useStyleRegistry_1
  };

  var style$1 = index.style;

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;
  function z(a) {
    if ("object" === _typeof(a) && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  var AsyncMode = l;
  var ConcurrentMode = m;
  var ContextConsumer = k;
  var ContextProvider = h;
  var Element = c;
  var ForwardRef = n;
  var Fragment = e;
  var Lazy = t;
  var Memo = r;
  var Portal = d;
  var Profiler = g;
  var StrictMode = f;
  var Suspense = p;
  var isAsyncMode = function isAsyncMode(a) {
    return A(a) || z(a) === l;
  };
  var isConcurrentMode = A;
  var isContextConsumer = function isContextConsumer(a) {
    return z(a) === k;
  };
  var isContextProvider = function isContextProvider(a) {
    return z(a) === h;
  };
  var isElement = function isElement(a) {
    return "object" === _typeof(a) && null !== a && a.$$typeof === c;
  };
  var isForwardRef = function isForwardRef(a) {
    return z(a) === n;
  };
  var isFragment = function isFragment(a) {
    return z(a) === e;
  };
  var isLazy = function isLazy(a) {
    return z(a) === t;
  };
  var isMemo = function isMemo(a) {
    return z(a) === r;
  };
  var isPortal = function isPortal(a) {
    return z(a) === d;
  };
  var isProfiler = function isProfiler(a) {
    return z(a) === g;
  };
  var isStrictMode = function isStrictMode(a) {
    return z(a) === f;
  };
  var isSuspense = function isSuspense(a) {
    return z(a) === p;
  };
  var isValidElementType = function isValidElementType(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  var typeOf = z;
  var reactIs_production_min = {
    AsyncMode: AsyncMode,
    ConcurrentMode: ConcurrentMode,
    ContextConsumer: ContextConsumer,
    ContextProvider: ContextProvider,
    Element: Element,
    ForwardRef: ForwardRef,
    Fragment: Fragment,
    Lazy: Lazy,
    Memo: Memo,
    Portal: Portal,
    Profiler: Profiler,
    StrictMode: StrictMode,
    Suspense: Suspense,
    isAsyncMode: isAsyncMode,
    isConcurrentMode: isConcurrentMode,
    isContextConsumer: isContextConsumer,
    isContextProvider: isContextProvider,
    isElement: isElement,
    isForwardRef: isForwardRef,
    isFragment: isFragment,
    isLazy: isLazy,
    isMemo: isMemo,
    isPortal: isPortal,
    isProfiler: isProfiler,
    isStrictMode: isStrictMode,
    isSuspense: isSuspense,
    isValidElementType: isValidElementType,
    typeOf: typeOf
  };

  var reactIs_development = createCommonjsModule(function (module, exports) {

    if (process.env.NODE_ENV !== "production") {
      (function () {

        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.
        var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' ||
          // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (_typeof(object) === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode

        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

              console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  });
  var reactIs_development_1 = reactIs_development.AsyncMode;
  var reactIs_development_2 = reactIs_development.ConcurrentMode;
  var reactIs_development_3 = reactIs_development.ContextConsumer;
  var reactIs_development_4 = reactIs_development.ContextProvider;
  var reactIs_development_5 = reactIs_development.Element;
  var reactIs_development_6 = reactIs_development.ForwardRef;
  var reactIs_development_7 = reactIs_development.Fragment;
  var reactIs_development_8 = reactIs_development.Lazy;
  var reactIs_development_9 = reactIs_development.Memo;
  var reactIs_development_10 = reactIs_development.Portal;
  var reactIs_development_11 = reactIs_development.Profiler;
  var reactIs_development_12 = reactIs_development.StrictMode;
  var reactIs_development_13 = reactIs_development.Suspense;
  var reactIs_development_14 = reactIs_development.isAsyncMode;
  var reactIs_development_15 = reactIs_development.isConcurrentMode;
  var reactIs_development_16 = reactIs_development.isContextConsumer;
  var reactIs_development_17 = reactIs_development.isContextProvider;
  var reactIs_development_18 = reactIs_development.isElement;
  var reactIs_development_19 = reactIs_development.isForwardRef;
  var reactIs_development_20 = reactIs_development.isFragment;
  var reactIs_development_21 = reactIs_development.isLazy;
  var reactIs_development_22 = reactIs_development.isMemo;
  var reactIs_development_23 = reactIs_development.isPortal;
  var reactIs_development_24 = reactIs_development.isProfiler;
  var reactIs_development_25 = reactIs_development.isStrictMode;
  var reactIs_development_26 = reactIs_development.isSuspense;
  var reactIs_development_27 = reactIs_development.isValidElementType;
  var reactIs_development_28 = reactIs_development.typeOf;

  var reactIs = createCommonjsModule(function (module) {

    if (process.env.NODE_ENV === 'production') {
      module.exports = reactIs_production_min;
    } else {
      module.exports = reactIs_development;
    }
  });
  var reactIs_1 = reactIs.typeOf;
  var reactIs_2 = reactIs.isElement;
  var reactIs_3 = reactIs.isValidElementType;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  var printWarning = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has$1 = has;
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has$1(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  var checkPropTypes_1 = checkPropTypes;

  var printWarning$1 = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning$1 = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && _typeof(data) === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!reactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning$1('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = objectAssign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (_typeof(propValue)) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = _typeof(propValue);
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = reactIs;

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = factoryWithThrowingShims();
    }
  });

  var DesktopAltoshift$1 = function DesktopAltoshift(props) {
    var hasRating = props.product.rating.average > 0;
    var font_family = props.font_family;
    return /*#__PURE__*/React.createElement("div", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-card-altoshift"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.product_url ? props.product_url : props.reviews_link + props.link.path,
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-image"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      src: !!props.product_image ? props.product_image : !!props.product.image && props.product.image !== '' ? props.product.image : 'https://image.femaledaily.com/dyn/200/images/prod-pics/placeholder_product.png',
      alt: "product",
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]])
    })), /*#__PURE__*/React.createElement("div", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "detail-wrapper"
    }, hasRating > 0 && /*#__PURE__*/React.createElement("p", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-detail"
    }, /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-rating-average"
    }, !!props.product_rating ? props.product_rating : props.product.rating.average), /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-rating-stars"
    }, /*#__PURE__*/React.createElement(RatingStar, {
      is_mobile: props.is_mobile,
      type: 1,
      rating: !!props.product_rating ? props.product_rating : props.product.rating.average
    })), /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-rating-total"
    }, "(", !!props.product_total_rating ? props.product_total_rating : props.product.rating.total, ")")), props.product.brand || !!props.brand_name && !!props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-brand"
    }, !!props.brand_name ? props.brand_name : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-brand"
    }, !!props.brand_name ? props.brand_name : props.product.brand.name), /*#__PURE__*/React.createElement("a", {
      href: !!props.product_url ? props.product_url : props.reviews_link + props.link.path,
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      id: props.element_id,
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-title"
    }, !!props.product_name ? props.product_name : props.product.name), props.product.shade || props.product_shade ? /*#__PURE__*/React.createElement("p", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-shade"
    }, !!props.product_shade ? props.product_shade : props.product.shade) : null, props.product.brand || !!props.brand_name && !!props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-price"
    }, !!props.product.price ? props.product.price : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: style$1.dynamic([["754352328", [hasRating ? "center" : "start", font_family, font_family, font_family]]]) + " " + "product-price"
    }, !!props.product.price ? props.product.price : props.product.brand.name)), /*#__PURE__*/React.createElement(style$1, {
      id: "754352328",
      dynamic: [hasRating ? "center" : "start", font_family, font_family, font_family]
    }, ".product-card-altoshift.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;-webkit-align-items:".concat(hasRating ? "center" : "start", ";-webkit-box-align:").concat(hasRating ? "center" : "start", ";-ms-flex-align:").concat(hasRating ? "center" : "start", ";align-items:").concat(hasRating ? "center" : "start", ";font-family:").concat(font_family, ";cursor:pointer;}.product-card-altoshift.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{margin:0;}.product-card-altoshift.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{-webkit-text-decoration:none;text-decoration:none;-webkit-transition:all .4s ease-out;transition:all .4s ease-out;}.product-card-altoshift.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector:hover{color:#D7244E !important;}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector{width:30%;max-width:30%;margin-right:16px;-webkit-transition:all .4s ease-out;transition:all .4s ease-out;opacity:1;}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector:hover{opacity:.6;}.product-card-altoshift.__jsx-style-dynamic-selector .detail-wrapper.__jsx-style-dynamic-selector{width:calc(83% - 16px);max-width:calc(83% - 16px);}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector img.__jsx-style-dynamic-selector{max-width:100%;}.product-card-altoshift.__jsx-style-dynamic-selector .product-detail.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-average.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-style:normal;font-weight:bold;font-size:12px;line-height:14px;color:#000000;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-stars.__jsx-style-dynamic-selector{margin:0 4px;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-stars.__jsx-style-dynamic-selector i.__jsx-style-dynamic-selector{font-size:12px;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-total.__jsx-style-dynamic-selector{font-weight:normal;font-size:12px;line-height:14px;color:#C4CDD5;}.product-card-altoshift.__jsx-style-dynamic-selector .product-title.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-weight:400;font-size:12px;line-height:16px;color:#000000;-webkit-text-decoration:none;text-decoration:none;margin-top:4px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}.product-card-altoshift.__jsx-style-dynamic-selector .product-shade.__jsx-style-dynamic-selector{font-weight:normal;font-size:12px;line-height:14px;color:#454F5B;margin-top:4px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}.product-card-altoshift.__jsx-style-dynamic-selector .product-brand.__jsx-style-dynamic-selector{font-weight:600;font-size:12px;line-height:14px;color:#000;margin-top:4px;display:block;-webkit-text-decoration:none;text-decoration:none;}.product-card-altoshift.__jsx-style-dynamic-selector .product-price.__jsx-style-dynamic-selector{font-weight:600;font-size:14px;line-height:14px;color:#000;margin:8px 0;display:block;-webkit-text-decoration:none;text-decoration:none;}.product-card-altoshift.__jsx-style-dynamic-selector .product-text-first-review.__jsx-style-dynamic-selector{font-size:12px;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=desktop.js */")));
  };
  DesktopAltoshift$1.propTypes = {
    font_family: propTypes.string
  };
  DesktopAltoshift$1.defaultProps = {
    font_family: "Poppins, sans-serif"
  };

  var MobileAltoshift$1 = function MobileAltoshift(props) {
    var hasRating = props.product.rating.average > 0;
    var font_family = props.font_family;
    return /*#__PURE__*/React.createElement("div", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-card-altoshift"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.product_url ? props.product_url : props.reviews_link + props.link.path,
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-image"
    }, /*#__PURE__*/React.createElement("img", {
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      src: !!props.product_image ? props.product_image : !!props.product.image && props.product.image !== '' ? props.product.image : 'https://image.femaledaily.com/dyn/60/images/prod-pics/placeholder_product.png',
      alt: "product",
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]])
    })), /*#__PURE__*/React.createElement("div", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-detail"
    }, hasRating && /*#__PURE__*/React.createElement("p", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-rating"
    }, /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-rating-average"
    }, !!props.product_rating ? props.product_rating : props.product.rating.average), /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-rating-stars"
    }, /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "cardrv-starlist"
    }, /*#__PURE__*/React.createElement("i", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "icon-ic_star_small fs12 margin-right"
    }))), /*#__PURE__*/React.createElement("span", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-rating-total"
    }, "(", !!props.product_rating ? props.product_rating : props.product.rating.total, ")")), props.product.brand || props.brand_name && props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-brand"
    }, !!props.brand_name ? props.brand_name : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-brand"
    }, !!props.brand_name ? props.brand_name : props.product.brand.name), /*#__PURE__*/React.createElement("a", {
      href: !!props.product_url ? props.product_url : props.reviews_link + props.link.path,
      onClick: function onClick() {
        return props.goto_altoshift(props.data, props.self_host);
      },
      id: props.element_id,
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-title"
    }, !!props.product_name ? props.product_name : props.product.name), !!props.product_shade ? props.product_shade : props.product.shade ? /*#__PURE__*/React.createElement("p", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-shade"
    }, !!props.product_shade ? props.product_shade : props.product.shade) : null, props.product.brand || !!props.brand_name && !!props.brand_url ? /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : "".concat(props.reviews_link, "/brands/").concat(props.product.brand.slug, "?tab=products&parent=&current=&order=popular&page=1"),
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-price"
    }, !!props.product.price ? props.product.price : props.product.brand.name) : /*#__PURE__*/React.createElement("a", {
      className: style$1.dynamic([["3153241447", [font_family, font_family, font_family, font_family, font_family, font_family]]]) + " " + "product-price"
    }, !!props.product.price ? props.product.price : props.product.brand.name)), /*#__PURE__*/React.createElement(style$1, {
      id: "3153241447",
      dynamic: [font_family, font_family, font_family, font_family, font_family, font_family]
    }, ".product-card-altoshift.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;-webkit-align-items:start;-webkit-box-align:start;-ms-flex-align:start;align-items:start;font-family:".concat(font_family, ";cursor:pointer;}.product-card-altoshift.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{margin:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}.product-card-altoshift.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{-webkit-text-decoration:none;text-decoration:none;-webkit-transition:all 0.4s ease-out;transition:all 0.4s ease-out;}.product-card-altoshift.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector:hover{color:#d7244e !important;}.product-card-altoshift.__jsx-style-dynamic-selector .product-detail.__jsx-style-dynamic-selector{width:79.2%;max-width:79.2%;}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector{width:100vw;max-width:13vw;margin-right:16px;-webkit-transition:all 0.4s ease-out;transition:all 0.4s ease-out;opacity:1;}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector:hover{opacity:0.6;}.product-card-altoshift.__jsx-style-dynamic-selector .detail-wrapper.__jsx-style-dynamic-selector{width:calc(79.5% - 16px);max-width:calc(79.5% - 16px);}.product-card-altoshift.__jsx-style-dynamic-selector .product-image.__jsx-style-dynamic-selector img.__jsx-style-dynamic-selector{max-width:100%;}f.__jsx-style-dynamic-selector .product-card-altoshift.__jsx-style-dynamic-selector .product-rating.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-average.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-style:normal;font-weight:bold;font-size:10px;line-height:14px;color:#000000;}.cardrv-starlist.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-stars.__jsx-style-dynamic-selector{margin:0 4px;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-stars.__jsx-style-dynamic-selector i.__jsx-style-dynamic-selector{font-size:10px;}.product-card-altoshift.__jsx-style-dynamic-selector .product-rating-total.__jsx-style-dynamic-selector{font-weight:normal;font-size:10px;line-height:14px;color:#c4cdd5;}.product-card-altoshift.__jsx-style-dynamic-selector .product-title.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-weight:400;font-size:10px;line-height:16px;color:#000000;-webkit-text-decoration:none;text-decoration:none;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}.product-card-altoshift.__jsx-style-dynamic-selector .product-shade.__jsx-style-dynamic-selector{font-weight:normal;font-size:12px;line-height:14px;color:#454f5b;margin-top:4px;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;}.product-card-altoshift.__jsx-style-dynamic-selector .product-brand.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-weight:600;font-size:10px;line-height:14px;color:#000;display:block;-webkit-text-decoration:none;text-decoration:none;}.product-card-altoshift.__jsx-style-dynamic-selector .product-price.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-weight:600;font-size:12px;line-height:14px;color:#000;margin-top:2px;display:block;-webkit-text-decoration:none;text-decoration:none;}.product-card-altoshift.__jsx-style-dynamic-selector .product-text-first-review.__jsx-style-dynamic-selector{font-family:").concat(font_family, ";font-size:12px;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=mobile.js */")));
  };
  MobileAltoshift$1.propTypes = {
    font_family: propTypes.string
  };
  MobileAltoshift$1.defaultProps = {
    font_family: "Poppins, sans-serif"
  };

  var ProductCard = function ProductCard(_ref) {
    var is_mobile = _ref.is_mobile,
      product_name = _ref.product_name,
      product_price = _ref.product_price,
      product_url = _ref.product_url,
      product_url_image = _ref.product_url_image,
      product_image = _ref.product_image,
      product_shade = _ref.product_shade,
      brand_url = _ref.brand_url,
      brand_name = _ref.brand_name,
      card_align = _ref.card_align,
      card_position = _ref.card_position,
      product_texts_lines = _ref.product_texts_lines,
      rating = _ref.rating,
      total_rating = _ref.total_rating,
      default_class = _ref.default_class,
      element_id = _ref.element_id,
      image_id = _ref.image_id,
      title_id = _ref.title_id,
      brand_id = _ref.brand_id,
      matches = _ref.matches;
    var props = {
      is_mobile: is_mobile || false,
      product_name: product_name || null,
      product_price: product_price || null,
      product_url: product_url || null,
      product_url_image: product_url_image || product_url || null,
      product_image: product_image || "https://image.femaledaily.com/dyn/200/images/prod-pics/placeholder_product.png",
      product_shade: product_shade || null,
      brand_url: brand_url || null,
      brand_name: brand_name || null,
      card_align: card_align || "center",
      card_position: card_position || null,
      product_texts_lines: product_texts_lines || 1,
      rating: rating || null,
      total_rating: total_rating || null,
      default_class: default_class || null,
      element_id: element_id || null,
      image_id: image_id || null,
      title_id: title_id || null,
      brand_id: brand_id || null,
      matches: matches || null
    };
    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    }
    return /*#__PURE__*/React.createElement(Desktop, props);
  };
  var Template = {
    "default": {
      "mobile": MobileAltoshift,
      "desktop": DesktopAltoshift
    },
    "fds": {
      "mobile": MobileAltoshift$1,
      "desktop": DesktopAltoshift$1
    }
  };
  var ProductCardAltoshift = function ProductCardAltoshift(_ref2) {
    var is_mobile = _ref2.is_mobile,
      product = _ref2.product,
      product_image = _ref2.product_image,
      product_name = _ref2.product_name,
      product_shade = _ref2.product_shade,
      product_rating = _ref2.product_rating,
      product_total_rating = _ref2.product_total_rating,
      product_url = _ref2.product_url,
      brand_name = _ref2.brand_name,
      brand_url = _ref2.brand_url,
      reviews_link = _ref2.reviews_link,
      goto_altoshift = _ref2.goto_altoshift,
      self_host = _ref2.self_host,
      search_text = _ref2.search_text,
      self = _ref2.self,
      session_id = _ref2.session_id,
      element_id = _ref2.element_id,
      type = _ref2.type,
      font_family = _ref2.font_family;
    var props = {
      is_mobile: is_mobile || false,
      product: product || {},
      reviews_link: reviews_link || "",
      self_host: self_host || "",
      search_text: search_text || "",
      session_id: session_id || "",
      product_image: product_image || null,
      product_name: product_name || null,
      product_shade: product_shade || null,
      product_rating: product_rating || null,
      product_total_rating: product_total_rating || null,
      product_url: product_url || null,
      brand_name: brand_name || null,
      brand_url: brand_url || null,
      self: self || {},
      element_id: element_id || null,
      goto_altoshift: goto_altoshift || function () {
        return false;
      },
      type: type || "default",
      font_family: font_family || null
    };
    var pathname = "/product";
    var query = {
      parent: props.product.category.parent.slug,
      child: props.product.category.slug,
      brand: props.product.brand.slug,
      product: props.product.slug,
      page: 1,
      tab: "reviews",
      cat: "",
      cat_id: 0,
      age_range: "",
      skin_type: "",
      skin_tone: "",
      skin_undertone: "",
      hair_texture: "",
      hair_type: "",
      order: "newest"
    };
    var path = "/products/".concat(query.parent, "/").concat(query.child, "/").concat(query.brand, "/").concat(query.product, "?") + "tab=".concat(query.tab, "&") + "cat=&" + "cat_id=0&" + "age_range=&" + "skin_type=&" + "skin_tone=&" + "skin_undertone=&" + "hair_texture=&" + "hair_type=&" + "order=".concat(query.order, "&") + "page=1";
    var data = {
      searchQuery: props.search_text,
      token: "5d317d61f6ea1802a00607a7-1563524449650-50169470",
      productId: props.product.id,
      itemId: props.product.item_id,
      method: "All",
      timeZone: "Asia/Jakarta",
      // sessionId: !!props.self.id ? props.self.data.id : ga.getAll()[0].get('clientId'),
      sessionId: props.session_id,
      searchCounter: "1",
      title: props.product.name,
      url: path,
      searchId: props.product.search_id
    };
    if (is_mobile) {
      var MobileAltoshift = Template[props.type]["mobile"];
      return /*#__PURE__*/React.createElement(MobileAltoshift, _extends({}, props, {
        link: {
          pathname: pathname,
          query: query,
          path: path
        },
        data: data
      }));
    }
    var DesktopAltoshift = Template[props.type]["desktop"];
    return /*#__PURE__*/React.createElement(DesktopAltoshift, _extends({}, props, {
      link: {
        pathname: pathname,
        query: query,
        path: path
      },
      data: data
    }));
  };
  var product_card = {
    ProductCard: ProductCard,
    ProductCardAltoshift: ProductCardAltoshift
  };

  return product_card;

})));
//# sourceMappingURL=product_card.umd.js.map
